export const messagesError = {
	name: {
		required: 'Por favor, insira seu nome.',
		shortName: 'Por favor, insira seu nome e sobrenome.',
		minlength: 'Por favor, insira um nome com mais de 6 caracteres.',
		maxlength: 'Por favor, insira um nome com menos de 50 caracteres.',
	},
	email: {
		required: 'Por favor, insira um email.',
		already_exist:
			'Este email já existe. Faça login ou entre em contato com o suporte.',
	},
};
